// Highlights the passion label matching the active team carousel slide.
import { onReady } from '../utils/ready.js';

function norm(t) {
  return (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
}

export function initTeamPassions() {
  onReady(function () {
    var c = document.querySelector('.team__carousel');
    var ps = [].slice.call(document.querySelectorAll('.team__passion-item > p:first-child'));
    if (!c || !ps.length) return;
    function update() {
      var lab = document.querySelector('.team .swiper-slide-active .disc-team__label > :last-child');
      var key = norm(lab && lab.textContent);
      ps.forEach(function (p) {
        p.classList.toggle('team__accent', !!key && norm(p.textContent) === key);
      });
    }
    var tries = 0;
    (function hook() {
      var sw = c.swiper;
      if (sw) {
        sw.on('slideChange', update);
        sw.on('slideChangeTransitionStart', update);
        update();
      } else if (tries++ < 40) {
        setTimeout(hook, 150);
      }
    })();
  });
}
